import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/schedulePay`;

class SchedulePayService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getTotalsByYear(currentYear) {
        return axios.get(`${API_URL}/totals/${currentYear}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(payFilter) {
        return axios.post(`${API_URL}/filter`, payFilter, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterCredit(payFilter) {
        return axios.post(`${API_URL}/filter-credit`, payFilter, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterRow(payFilter) {
        return axios.post(`${API_URL}/filter-row`, payFilter, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(pay) {
        return axios.put(`${API_URL}/update`, pay, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    addCreditNote(credit) {
        return axios.post(`${API_URL}/newCredit`, credit, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getCreditNote(idSchedulePay) {
        return axios.get(`${API_URL}/getCreditNote`, {
            params: {
                idSchedulePay: idSchedulePay,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    updateCredit(pay) {
        return axios.put(`${API_URL}/update-credit`, pay, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new SchedulePayService();